// 中文
export default {
  common: {
    confirm: '确定',
    submit: '提交',
    search: '查询',
    loadMore: '加载更多',
    loading: '加载中...',
    cancel: '取消',
    back: '返回',
    noData: '暂无数据',
    copy: '复制',
    copied: '已复制',
    copyFailed: '复制失败',
  },
  lang: {
    label: '语言',
    es: 'Español',
    zh: '中文',
    en: 'English',
  },
  tabbar: {
    home: '首页',
    query: '查询',
    info: '订单',
    my: '我的',
  },
  login: {
    user: '账号',
    userPlaceholder: '请输入 8 位电话号码',
    password: '密码',
    passwordPlaceholder: '密码',
    submit: '登录',
    createAccount: '注册账号',
      userMustBe8Digits: '账号必须为 8 位数字',
},
  register: {
    user: '账号',
    userPlaceholder: '请输入 8 位电话号码',
    password: '密码',
    passwordPlaceholder: '密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '确认密码',
    confirmPasswordRequired: '请确认密码',
    name: '姓名',
    namePlaceholder: '姓名',
    sinpe: 'SINPE 手机号',
    sinpePlaceholder: 'SINPE 手机号',
    sinpeRequired: '手机号',
    submit: '注册',
    submitting: '提交中...',
    backToLogin: '返回登录页面',
    passwordMismatch: '两次密码不一致',
    success: '注册成功',
    fail: '注册失败',
      userMustBe8Digits: '账号必须为 8 位数字',
},
  home: {
    noLottery: '当前暂无彩票',
    paga: '赔付',
    saldo: '余额',
    monto: '金额',
    rMonto: 'R金额',
    total: '合计',
    reventados: '加倍(REVENTADOS)',
    colNum: '号码',
    colAmount: '₡',
    colReve: '加倍',
    colSorteo: '期数',
    betList: '投注列表',
    order: '下单',
    orderSuccess: '下单成功',
    orderFail: '下单失败',
    selectLottery: '请选择彩票后下单',
    enterAmountRight: '请在右侧输入金额',
    selectNumAndAmount: '请选择彩票号码和金额',
    selectNum: '请选择彩票号码',
    changeProductTitle: '确定要切换产品吗？',
    changeProductMessage: '当前已选择彩票，如果切换，之前所选将丢失。',
    sorteo: '期数',
  },
  successOrder: {
    title: '打印',
    validFor: '仅适用于:',
    mobile: '手机号:',
    date: '日期:',
    invoice: '票号:',
    paga: '赔付:',
    colNum: '号码',
    colAmount: '₡',
    colReve: '加倍',
    total: '合计:',
    note1: '** 中奖后7天内兑奖 **',
    note2: '** 付款前请核对 **',
    note3: '** 概不受理投诉 **',
    note4: '** 无票不予兑付 **',
    sellerSign: '销售员签名:__________________',
    thanks: '感谢您的投注',
    print: '打印',
      continueOrder: '继续下单',
    sendWhatsApp: 'WhatsApp 发送订单',
},
  order: {
    listTitle: '订单信息',
    detailTitle: '订单详情',
    status: '状态:',
    statusValid: '有效',
    orderNo: '订单号:',
    colNum: '号码',
    colAmount: '₡',
    colReve: '加倍',
  },
  query: {
    winningTab: '中奖查询',
    rechargeTab: '充值查询',
    withdrawTab: '提现查询',
    startTime: '开始时间',
    startTimePlaceholder: '点击选择时间',
    endTime: '结束时间',
    endTimePlaceholder: '开始时间',
    pickerTitle: '请选择年月日',
    time: '时间:',
    rechargeAmount: '充值金额:',
    withdrawAmount: '提现金额:',
    sorteo: '期数:',
    lottery: '彩票:',
    number: '号码:',
    amount: '金额:',
    pendingRecharges: '待处理充值',
  },
  my: {
    account: '账号:',
    balance: '余额:',
    withdrawing: '提现中:',
    recharge: '充值',
    withdraw: '提现',
    changePassword: '修改密码',
    messageCenter: '消息中心',
    logout: '退出登录',
  },
  recharge: {
    title: '充值',
    method: '转入方式',
    methodPlaceholder: '点击选择充值方式',
    methodRequired: '请选择支付方式',
    amount: '充值金额',
    amountPlaceholder: '请输入充值金额',
    minAmount: '充值金额必须大于100',
      arrivedTitle: '充值到账',
    arrivedHint: '您的账户已收到充值',
    newBalance: '当前余额',
    sinpeNoticeTitle: '重要:必填提示',
    sinpeNoticeBody: '转账时,请务必在 SINPE Móvil 的"Descripción (opcional)"栏里填写您的账号手机号,否则可能无法自动到账,需要人工审核延迟到账。',
    sinpeNoticeTail: '示例:您的手机号填在描述里 ↑',
    paymentInfo: '支付信息',
    accountNo: '收款账号',
    yourMobile: '您的手机号',
    submittedTitle: '充值请求已提交',
    submittedHint: '现在打开您的银行 App 转账。转账时可以随时切回来复制信息:',
    sinpeReminder: '别忘了在 SINPE Descripción 里填您的手机号,否则可能无法自动到账',
    gotIt: '我知道了',
    accountName: '收款人',
    orderId: '订单号',
    pendingTitle: '待处理充值',
    viewInfo: '查看信息',
  },
  withdraw: {
    title: '提现',
    amount: '金额',
    amountPlaceholder: '请输入要提现的金额',
    minAmount: '提现金额必须大于100',
    success: '提现申请成功，请等待SINPE',
      completedTitle: '提现完成',
    completedHint: '您的提现申请已处理完成',
},
  message: {
    title: '消息中心',
    newMessage: '新消息',
    newMessageText: '你有一条关于:{title}的新消息',
  },
  changePassword: {
    title: '修改密码',
    oldPassword: '旧密码',
    oldPasswordPlaceholder: '请输入旧密码',
    password: '密码',
    passwordPlaceholder: '请输入新密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    passwordMismatch: '两次密码不一致，请重新输入',
  },
  setting: {
    title: '设置',
    changeAvatar: '修改图像',
    changePassword: '修改密码',
    changePrint: '修改打印参数',
    avatarTitle: '修改头像',
    printTitle: '修改打印模板',
    selectFirst: '请先选择后提交',
  },
  routeTitle: {
    Home: '首页',
    Query: '综合查询',
    Order: '订单信息',
    OrderDetail: '订单详情',
    My: '我的',
    Setting: '设置',
    Avatar: '上传头像',
    ChangePassword: '修改密码',
    PrintTemplate: '修改打印模板',
    Recharge: '充值中心',
    Message: '消息中心',
    Withdraw: '提现中心',
    SuccessOrder: '订单详情',
    login: '登录',
    register: '注册',
  },
};
